import React, { Component, createElement } from 'react';
import Popup from 'reactjs-popup';
import { store } from '../store';

const singlecolumn = require('./icons/singlecolumn.svg');
const twocolumn = require('./icons/twocolumn.svg');
const addnewrow = require('./icons/add-new-row.svg');
const addelement = require('./icons/add-element.svg');

interface Props {
    type: string;
    targetArray: any[];
    targetIndex: number;
    styleName?: any;
    element?: any;
}

const section = {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
};

const label = {
    float: 'right',
    color: 'black',
    fontSize: '13px',
    lineHeight: '20px',
};

const icon = {
    padding: '10px',
};

const popupMenu = {
    width: '450px',
    display: 'flex',
    flexWrap: 'wrap',
};

class AddRowComponent extends Component<Props, any> {
    render() {
        let isStyleName = this.props.styleName;
        let isColumn = this.props.type === 'column';
        return (
            <div style={isStyleName ? { position: 'relative', width: store.currentTemplate.pageSettings.width + 'px', margin: '0px auto' } : { border: '0px solid black', paddingTop: '20px', height: '30px', width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Popup
                    keepTooltipInside={true}
                    contentStyle={isColumn ? {} : { width: 450 }}
                    trigger={(open) => (
                        <img title={isStyleName === 'top' ? 'Add Row above' : isStyleName === 'bottom' ? 'Add Row Below' : this.props.element === 'element' ? 'Add Element' : 'Add New Row'} className="addrow-btn" style={isStyleName == 'bottom' ? { position: 'absolute', bottom: '-10px', left: '-60px', zIndex: 1 } : isStyleName == 'top' ? { position: 'absolute', top: '-10px', left: '-60px', zIndex: 1 } : { cursor: 'pointer' }} src={addnewrow} />
                    )}
                    position="bottom center"
                    closeOnDocumentClick>
                    {(close) => (
                        <div style={isColumn ? {} : popupMenu}>
                            {store.components
                                .filter((c) => c.type === this.props.type)
                                .map((c) => {
                                    return (
                                        <div
                                            style={isColumn ? {} : { width: 150 }}
                                            className="close"
                                            onClick={(e) => {
                                                let t = JSON.parse(JSON.stringify(c.defaultTemplate));
                                                t.id = +new Date();
                                                this.props.targetArray.splice(this.props.targetIndex, 0, t);
                                                close();
                                            }}>
                                            <div style={section}>
                                                <img src={c.svg} style={isColumn ? {} : icon} />
                                                {c.type === 'column' ? null : <span style={label}>{c.defaultTemplate.name}</span>}
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    )}
                </Popup>
            </div>
        );
    }
}

const Card = ({ title }) => (
    <div className="card">
        <div className="header">{title} position </div>
        <div className="content">Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit autem sapiente labore architecto exercitationem optio quod dolor cupiditate</div>
    </div>
);

const ToolTipPositions = () => (
    <div className="example-warper">
        <Popup trigger={<button className="addrow-btn"> Right Top </button>} on="click">
            <Card />
        </Popup>
    </div>
);

export default AddRowComponent;
